import axios from 'axios';

const api = axios.create({ baseURL : 'http://criaresuporte1.no-ip.info:9000' });

export default api;